
$(document).ready(function () {

  $("body").on("click", ".clio-country ul, .clio-country-newsletter ul", function (e) {
    $(this).toggleClass('hover');
  })

  $("body").on("click", ".clio-country ul li", function (e) {
    e.preventDefault();
    let lang = $(this).attr("data-lang");
    const popup = $(this).closest(".popup-country").length;
    set_country(lang, popup);
  })

  $('.clio-country-newsletter option[value="---"]').html('Your country').attr("value", "").prevAll().remove();
  $('.clio-country-newsletter option[value="Italy"]').remove();

  /*
  $(".main-header h1.title a").click(function(e){
    e.preventDefault();
    set_country();
    location.reload();
  })*/

  function set_country(lang = "", popup = 0) {
    var d = new Date();
    d.setTime(d.getTime() + (5184000000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = "country=" + lang + ";" + expires + ";path=/";
    $(".clio-country ul li.selected").removeClass("selected");
    $(".clio-country ul li[data-lang='" + lang + "']").addClass("selected");
    if (!popup) {
      if (lang == "IT" && (clio_strings.locale.code !== "IT")) {
        window.location.replace('https://cliomakeupshop.com?lang=IT');
      } else if (lang !== "IT" && (clio_strings.locale.code == "IT")) {
        window.location.replace('https://international.cliomakeupshop.com');
      } else {
        //$(".clio-country ul").removeClass('hover');
      }
    }
  }

  function read_country() {
    if (!clio_strings.locale.enabled) {
      return 1;
    }
    var cookieCountry = "";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf("country=") == 0) {
        cookieCountry = c.substring("country=".length, c.length);
      }
    }
    if (!cookieCountry) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('lang')) {
        valid_countries = ["IT", "UK", "FR", "CH", "DE", "ES", "NL", "IE", "W"];
        cookieCountry = urlParams.get("lang");
        if (valid_countries.includes(cookieCountry)) {
          set_country(cookieCountry, 1);
        } else {
          cookieCountry = "";
        }
      }
    }
    return cookieCountry;
  }

  var initlang = read_country();
  if (initlang) {
    initlang = clio_strings.locale.code == "INT" ? "W" : "IT";
    $(".clio-country ul li[data-lang='" + initlang + "']").addClass("selected");
  } else {
    var gatepage = $("body").hasClass('template-password');
    if (!gatepage) {
      if (clio_strings.locale.code == "IT") {
        set_country("IT", 1);
      } else {
        set_country("W", 1);
      }
    }
  }

  $("body").on("click", ".popup-country a[href='#newsletter']", function (e) {
    e.preventDefault();
    $(".popup-country").addClass("disabled");
  })

  $("body").on("click", ".popup-country .subscribe", function (e) {
    e.preventDefault();
    if (read_country() == "IT" && (clio_strings.locale.code !== "IT")) {
      window.location.replace('https://cliomakeupshop.com?lang=IT');
    } else if (read_country() !== "IT" && (clio_strings.locale.code == "IT")) {
      window.location.replace('https://international.cliomakeupshop.com');
    } else {
      $(".popup-modal-close").trigger("click");
    }
  })

  // international ^^

  //viewitem on variant change
  window.firstvariantchange = true;
  document.addEventListener('variant:changed', function (event) {
    const variant = event.detail.variant;
    if (window.firstvariantchange) { window.firstvariantchange = false; return; }
    if (!variant) { return; }
    window.analyzify?.gtmViewItem(window.analyzify.getProductObj, variant.id);
  });

  //accordion
  // jQuery 3 made .unwrap(selector) filter the parent, so lift the title out of its
  // wrappers until it sits next to the content it toggles (CSS: .accordion + div).
  var accordionWrapper = /^(strong|b|em|i|u|span|font|p|h1|h2|h3|h4|h5|h6)$/i;
  $('.accordion').each(function () {
    var $title = $(this), $parent = $title.parent();
    while ($parent.length && (accordionWrapper.test($parent.prop('tagName')) ||
      ($parent.is('div') && $parent.children().not('br').length === 1))) {
      $title.unwrap();
      $parent = $title.parent();
    }
    $title.text($title.text())
  });
  $('.accordion').each(function () {
    $(this).nextUntil(".accordion").wrapAll("<div></div>");
    $(this).click(function (e) { e.preventDefault(); $(this).toggleClass('active') })
  });

  //form animation
  document.addEventListener('widgetform_send', function (e) {
    $("button.subscribe .icon").click()
    fbq('trackCustom', 'Newsletter', { type: 'default' })
  }, false);

  document.addEventListener('restockform_send', function (e) {
    $("button.subscribe .icon").click()
    fbq('trackCustom', 'Newsletter', { type: 'restock' })
  }, false);

  timeout = "";
  $(".quantity a").click(function (e) {
    e.preventDefault();
    $input = $(this).parent().find("input");
    qu = $input.val();
    maxvalue = parseFloat($input.attr("data-maxi"));
    if ($(this).hasClass("plus")) {
      var newVal = parseFloat(qu) + 1;
      if (maxvalue) {
        if (newVal > maxvalue) {
          newVal = maxvalue;
          return;
        }
      }
    } else {
      if (qu > 1) {
        var newVal = parseFloat(qu) - 1;
      } else {
        newVal = 1;
      }
    }
    $input.val(newVal);
    if (timeout) { clearInterval(timeout); }
    timeout = setTimeout(function () {
      //$("input[name=update]").click();
    }, 800);
  })

  $("a.updatecart").click(function (e) {
    e.preventDefault();
    $("input[name=update]").click();
  })


  setTimeout(function () {
    var form = document.querySelector('#subscribe-form-popup');
    if (form) { document.dispatchEvent(new CustomEvent('ClioLoadLightWidget', { detail: form })); }
  }, popup_config.seconds_until * 1000 + 1000);

  //cookie fix
  setTimeout(function () { $(".cookie-space").height($(".cc_container").outerHeight()); }, 1000);
  $(".cc_btn").click(function () { $(".cookie-space").height(0); })

  //back to top
  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      if (!$('.backtop').hasClass("up")) { $('.backtop').addClass("up"); }
    } else {
      if ($('.backtop').hasClass("up")) { $('.backtop').removeClass("up"); }
    }
  });

  //anchor
  $('a[href="#clio-newsletter-modal"]').click(function (e) {
    e.preventDefault()
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', popup_klaviyo_form]);
  })

  //swiper free scroll slider
  var swiper = new Swiper('.product-slider-new .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: true,
    freeModeSticky: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      420: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
      1280: { slidesPerView: 4 },
      1600: { slidesPerView: 5 },
      1920: { slidesPerView: 6 }
    }
  });

  //fetch promotions
  if (clio_strings.promotions.disable) {
    localStorage.removeItem("cmushop_promos")
  } else {
    if (clio_strings.promotions.endpoint && !$('body').hasClass('template-cart')) {
      if (localStorage.getItem("cmushop_promos") === null) {
        downloadPromos()
      } else {
        let promos = JSON.parse(localStorage.getItem("cmushop_promos"));
        const now = new Date()
        if (now.getTime() > promos.slice(-1).pop()) {
          localStorage.removeItem("cmushop_promos")
          downloadPromos()
        } else {
          clioNotify(promos);
        }
      }
    }
    $('body').on("click", ".clio-notify .button, .notify-toggle", function (e) {
      $('.clio-notify').removeClass("expo")
      e.preventDefault();
      if (localStorage.getItem("cmushop_notify") === null) {
        const now = new Date()
        localStorage.setItem("cmushop_notify", now.getTime() + 10800000)
        if (window.clio_minicart_pause) {
          const event = new Event('linkRecentCartItemPopUp')
          window.dispatchEvent(event)
        }
      } else {
        localStorage.removeItem("cmushop_notify")
      }
      $(".clio-notify").toggleClass("closed");
    })
    $('body').on("cartUpdate", function (e, totalraw) {
      localStorage.removeItem("cmushop_notify")
      const total = typeof totalraw === 'number' ? totalraw : parseFloat(totalraw.replace("€", "").replace("$", ""));
      let promos = JSON.parse(localStorage.getItem("cmushop_promos"));
      clioNotify(promos, total, true);
    })
  }
  function downloadPromos() {
    const now = new Date()
    let promos = [];
    fetch(clio_strings.promotions.endpoint).then(response => { return response.json() }).then(data => {
      if ("promotions" in data) {
        promos = data.promotions;
        promos.push(now.getTime() + 900000);
        localStorage.setItem("cmushop_promos", JSON.stringify(promos));
        clioNotify(promos);
      }
    })
  }
  function clioNotify(promos, total, delayMiniCart = false) {
    const now = new Date()
    let notify = false;
    if (!total) { total = clio_strings.total }
    promos.forEach(function (promo) {
      if (typeof promo === 'object' && promo !== null) {
        let promo_image = promo.image
        const promo_notifyafter = promo.conditions.notify_after
        const promo_type = promo.conditions.typology
        const promo_start = new Date((promo.start_time).replace(' ', 'T'));
        const promo_end = new Date((promo.end_time).replace(' ', 'T'));
        if (now.getTime() > promo_start.getTime() && now.getTime() < promo_end.getTime()) {
          if (promo_type == "PRICE") {
            const price_type = promo.conditions.check;
            const price = promo.conditions.value;
            if (price_type == 'OVER-EQUAL-PRICE') {
              if (total > promo_notifyafter && total < price) {
                notify = true;
                if (promo.actions.hasOwnProperty('items')) {
                  const products_gift = promo.actions.items;
                  promo_image = products_gift[0].image;
                  promo_title = products_gift[0].title;
                } else {
                  promo_image = promo.image;
                  promo_title = promo.name;
                }
                if (promo_image.includes('cliomakeup-GIFT-CARD1')) {
                  promo_image = 'https://cliomakeupshop.com/cdn/shop/files/GIFT-Cliomakeup-v2_1_128x128.png?v=1687794588';
                }
                $(".clio-notify, .notify-toggle").remove();
                const remain = price - total;
                const isCart = $('body').hasClass('template-cart');
                const priceText = price == 20 ? '2 prodotti' : (price + '€');
                const message = clio_strings.promotions.notify_banner.replace("%PRODUCT%", '<strong>' + promo_title + '</strong>').replace("%MONEY%", '<strong>' + remain.toFixed(2) + '€</strong>')
                const progressBar = '<ul class="promo-progress-bar"><li style="left: 100%;"><strong style="width: auto; right: 0; left: auto; white-space:nowrap">' + priceText + '</strong></li><li style="width:' + Math.min(total * 100 / price, 100) + '%" class="progress"></li></ul>';
                $('body').prepend('<div class="clio-notify closed"><section><div><img src="' + promo_image + '"/><p>' + message + '</p></div>' + progressBar + '<a class="btn button" href="#">' + clio_strings.promotions.notify_banner_button + '</a></section></div>');
                if (!isCart) {
                  $('<a href="#" class="notify-toggle"><span class="entypo-bell"><span class="number-wrapper "><span class="number">1</span></span></span></a>').insertAfter('.cart-link');
                }
                const notifyexpo = sessionStorage.getItem("cmushop_notifyexpo")
                const expiry = localStorage.getItem("cmushop_notify");
                if (notifyexpo) {
                  //
                } else {
                  sessionStorage.setItem("cmushop_notifyexpo", true)
                  $('.clio-notify').addClass("expo")
                }
                const now = new Date()
                if ((!isCart) && (expiry === null || now.getTime() > expiry)) {
                  localStorage.removeItem("cmushop_notify");
                  const delay = delayMiniCart ? 10 : 1000;
                  setTimeout(function () { $('.clio-notify').removeClass("closed") }, delay)
                  setTimeout(function () { $('.clio-notify .promo-progress-bar').addClass('animate'); }, delay + 500)
                } else {
                  $('.clio-notify .promo-progress-bar').addClass('animate');
                }
              }
            }
          }
        }
      }
    })
    if (!notify) {
      window.clio_minicart_pause = false
      $(".clio-notify, .notify-toggle").remove();
    } else if (delayMiniCart) {
      window.clio_minicart_pause = true
    }
  }
});

/* ═══════════════════════════════════════════════════════════════════════════
   Tag-Bundle-App — INIZIO — builder BYOB (Simple Bundles & Kits)
   ═══════════════════════════════════════════════════════════════════════════
   Il click su "Add" nella card del builder apre la modale invece di aggiungere.

   COMPORTAMENTO NATIVO DELL'APP (letto in byob-bundle.es.js, componente
   <byob-product-picker-card>):
     .byob-cta--add    → onAddClick     → mette SUBITO 1 pezzo nel bundle,
                                          nessuna modale, nessuna conferma
     immagine / titolo → openModal      → apre <dialog class="byob-options-modal">
                                          con varianti e selettore quantità
     .byob-cta--full   → onAddFromModal → aggiunge la quantità scelta e chiude
   Il pulsante della card è "Add" solo sui prodotti a variante unica; con più
   varianti diventa "Select" e apre già la modale. L'aggiunta immediata quindi
   non è un difetto dell'app: è il quick-add previsto. Qui lo dirottiamo sulla
   modale, così nulla entra nel bundle finché non si conferma la quantità, e il
   solo punto che aggiunge resta il CTA dentro la modale.
*/
(function () {
  var ADD_OPENS_MODAL = true;

  var CARD = 'byob-product-picker-card';
  var OPENERS =
    '.byob-bundle__product-card-media--clickable, .byob-bundle__product-card-title--clickable';
  // Finestra entro cui un secondo evento sullo stesso gesto è un'eco, non un
  // click voluto. showModal() su una <dialog> già aperta lancia InvalidStateError.
  var ECHO_MS = 600;

  var lastOpen = 0;
  var selfDispatch = false;
  var state;

  function stop(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function openModal(card, opener) {
    var dialog = card.querySelector('dialog.byob-options-modal');
    if (dialog && dialog.open) return;

    // Un click sintetico su immagine/titolo è l'unico modo per chiamare
    // openModal() dall'esterno: il componente non espone alcun metodo.
    selfDispatch = true;
    try {
      opener.click();
    } finally {
      selfDispatch = false;
    }
    lastOpen = Date.now();
    state.opened++;
  }

  function onClick(e) {
    if (selfDispatch) return;

    var t = e.target;
    if (!t || !t.closest || !t.closest(CARD)) return;

    var addBtn = ADD_OPENS_MODAL ? t.closest('.byob-cta--add') : null;
    if (addBtn) {
      var card = addBtn.closest(CARD);
      var opener = card && card.querySelector(OPENERS);
      // Senza un opener non saprei aprire la modale: meglio lasciar fare
      // all'app che lasciare un bottone morto.
      if (!opener) return;

      stop(e);
      state.blocked++;
      openModal(card, opener);
      return;
    }

    if (t.closest(OPENERS)) {
      if (Date.now() - lastOpen < ECHO_MS) {
        stop(e);
      } else {
        lastOpen = Date.now();
      }
      return;
    }

    // Click sul backdrop subito dopo l'apertura: è l'eco del click che ha aperto
    // la modale, non la volontà di chiuderla.
    if (
      t.matches &&
      t.matches('dialog.byob-options-modal') &&
      Date.now() - lastOpen < ECHO_MS
    ) {
      stop(e);
    }
  }

  function init() {
    if (window.__byobAddPatch) return;
    state = window.__byobAddPatch = {
      installed: true,
      addOpensModal: ADD_OPENS_MODAL,
      blocked: 0,
      opened: 0,
      installedAt: new Date().toISOString()
    };
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
/* ═══ Tag-Bundle-App — FINE ═══ */

/* ═══════════════════════════════════════════════════════════════════════════
   Tag-Bundle-App — INIZIO — Italian labels for the BYOB widget
   ═══════════════════════════════════════════════════════════════════════════
   Simple Bundles hardcodes its UI strings inside the widget instead of reading
   them from the theme locales, so neither Shopify's translation editor nor
   Translate & Adapt can reach them. Their support confirmed there is no native
   setting for it and filed a feature request, so overriding from the theme is
   currently the only option.

   The store is Italian only, hence a plain dictionary rather than the theme's
   locale files. Should a second language ever be added, move DICT and PATTERNS
   into locales/*.json and inject them from Liquid.

   Two label groups are NOT handled here because they are app settings, not
   hardcoded strings: the bundle title ("Test BYOB") and the mobile drawer title,
   which come from the product-title and mobile-title attributes on <byob-bundle>
   and are best changed in the app admin.
*/
(function () {
  var ROOT = 'byob-bundle';

  // Keys are normalised: lowercase, collapsed whitespace, no nbsp. Matching is
  // therefore case-insensitive, which also covers the labels the app renders in
  // a different case than the CSS displays them.
  var DICT = {
    'add': 'Aggiungi',
    'add a product': 'Aggiungi un prodotto',
    'add bundle to cart': 'Aggiungi il kit al carrello',
    'add to cart': 'Aggiungi al carrello',
    'added to cart': 'Aggiunto al carrello',
    'added': 'Aggiunto',
    'adding...': 'Aggiunta in corso...',
    'bundle summary': 'Riepilogo bundle',
    'close': 'Chiudi',
    // Nomi delle opzioni: non si vedono a schermo, l'app li usa come aria-label
    // del <select> di variante (nella card e nella modale). Restano in inglese
    // perché sono i nomi opzione del catalogo, non stringhe dell'app.
    'color': 'Colore',
    'variant': 'Variante',
    'decrease quantity': 'Diminuisci quantità',
    'done': 'Fatto',
    'hide items': 'Nascondi prodotti',
    'increase quantity': 'Aumenta quantità',
    'max quantity added': 'Quantità massima raggiunta',
    'max quantity reached': 'Quantità massima raggiunta',
    'out of stock': 'Non disponibile',
    'pack options': 'Opzioni confezione',
    'qty': 'Qtà',
    'quantity': 'Quantità',
    'remove': 'Rimuovi',
    'see full details': 'Vedi tutti i dettagli',
    'select': 'Scegli',
    'selected': 'Selezionato',
    'sold out': 'Esaurito',
    'subtotal': 'Subtotale',
    'total': 'Totale',
    'view items': 'Vedi prodotti',
    'your bundle': 'Il tuo kit'
  };

  function pieces(n) {
    return n === '1' ? '1 prodotto' : n + ' prodotti';
  }

  // Counters and discounts change with the bundle state, so these need a regex.
  var PATTERNS = [
    [/^add (\d+) more to get (\d+)% off$/i, function (m) {
      return 'Aggiungi ancora ' + pieces(m[1]) + ' per avere il ' + m[2] + '% di sconto';
    }],
    [/^add (\d+) more$/i, function (m) {
      return 'Aggiungi ancora ' + pieces(m[1]);
    }],
    [/^(\d+) of (\d+) selected$/i, function (m) {
      return m[1] + ' di ' + m[2] + ' selezionati';
    }],
    [/^save (\d+)%$/i, function (m) {
      return 'Risparmi il ' + m[1] + '%';
    }]
  ];

  var ATTRS = ['aria-label', 'placeholder'];

  // Strings we deliberately leave alone: the app's own attribution and the
  // Shopify placeholder for products without real variants.
  var SKIP = { 'powered by': 1, 'simple bundles': 1, 'default title': 1 };

  // Product names and descriptions live here and must never be touched. Only
  // the leaf nodes are listed, never their containers: __header and __content
  // also hold the "See full details" link and the modal CTA, which do need
  // translating. Everything else is safe anyway, since a string is rewritten
  // only on a full match against the dictionary.
  var CONTENT = [
    '.byob-bundle__product-card-title',
    '.byob-options-modal__title',
    '.byob-options-modal__desc',
    '.byob-resource__variant',
    '.byob-mini-cart__branding'
  ].join(',');

  var unknown = {};

  function normalise(s) {
    return s.replace(/ /g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function translate(raw) {
    var key = normalise(raw);
    if (!key || SKIP[key]) return null;
    if (DICT[key]) return DICT[key];

    for (var i = 0; i < PATTERNS.length; i++) {
      var m = key.match(PATTERNS[i][0]);
      if (m) return PATTERNS[i][1](m);
    }
    // Anything left that looks like plain English is worth reporting: the app
    // has states this snapshot never showed. See window.__byobI18n.missing().
    if (/^[a-z0-9][a-z0-9 ,.'%!?()-]{1,60}$/.test(key)) unknown[key] = (unknown[key] || 0) + 1;
    return null;
  }

  function translateTextNode(node) {
    var raw = node.nodeValue;
    if (!raw || !raw.trim()) return;
    if (node.parentElement && node.parentElement.closest(CONTENT)) return;

    var out = translate(raw);
    if (!out) return;

    // Surrounding whitespace is meaningful: several labels sit next to an inline
    // icon and would collide with it if trimmed.
    var lead = raw.match(/^\s*/)[0];
    var trail = raw.match(/\s*$/)[0];
    node.nodeValue = lead + out + trail;
  }

  function run(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(translateTextNode);

    for (var i = 0; i < ATTRS.length; i++) {
      var attr = ATTRS[i];
      var found = root.querySelectorAll('[' + attr + ']');
      Array.prototype.forEach.call(found, function (el) {
        var out = translate(el.getAttribute(attr));
        if (out) el.setAttribute(attr, out);
      });
    }
  }

  function init() {
    if (window.__byobI18n) return;

    var root = document.querySelector(ROOT);
    if (!root) return;

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        run(root);
      });
    }

    // The widget re-renders the cart and the cards on every add and remove, so
    // a one-shot pass is not enough. Rewriting is idempotent: a translated
    // string is no longer a key, so the observer settles after one round.
    var observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });

    run(root);

    window.__byobI18n = {
      run: function () { run(root); },
      missing: function () { return Object.keys(unknown).sort(); }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
/* ═══ Tag-Bundle-App — FINE ═══ */

/* ═══════════════════════════════════════════════════════════════════════════
   Tag-Bundle-App — INIZIO — hide the Simple Bundles branding
   ═══════════════════════════════════════════════════════════════════════════
   The widget renders "Powered by Simple Bundles" in the mini cart and pins it
   with inline !important styles, which win over any author stylesheet, so the
   CSS rule in clio.css is not enough on its own and the node has to be removed.

   The widget also carries a hide-branding attribute, driven by the app settings
   and currently "false". If the plan in use exposes that setting, switch it on
   in the app admin and drop this block: it survives app updates, this does not.
*/
(function () {
  var SEL = '.byob-mini-cart__branding';
  // The app could in principle put the badge back on every removal. Capping the
  // rounds keeps a tug of war from burning the main thread.
  var LIMIT = 50;

  var removed = 0;

  function strip(root, observer) {
    var nodes = root.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].parentNode.removeChild(nodes[i]);
      removed++;
    }
    if (removed > LIMIT && observer) {
      observer.disconnect();
      console.warn('[clio] branding BYOB: rimozioni oltre il limite, osservatore fermato');
    }
  }

  function init() {
    if (window.__byobNoBranding) return;

    var root = document.querySelector('byob-bundle');
    if (!root) return;
    window.__byobNoBranding = true;

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        strip(root, observer);
      });
    });

    // The mini cart is rebuilt on every add and remove, and the badge comes back
    // with it, so a single pass at load would not hold.
    observer.observe(root, { childList: true, subtree: true });
    strip(root, observer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
/* ═══ Tag-Bundle-App — FINE ═══ */

/* ═══════════════════════════════════════════════════════════════════════════
   Tag-Bundle-App — INIZIO — swatch per gli Infinite Options bundle
   ═══════════════════════════════════════════════════════════════════════════
   Simple Bundles fa scegliere i prodotti di un Infinite Options bundle con dei
   <select> testuali. Qui ci disegniamo sopra gli swatch tinta del tema.

   PERCHÉ UN PROXY E NON UNA UI NUOVA
   Lo snippet ufficiale dell'app (art. 389) sostituisce i select con una propria
   UI che si scrive da sola properties[<gruppo>] e properties[_bundle_selection].
   Ma quel campo lo possiede simple-bundles-v2.min.js, che lo ricalcola a ogni
   change e ci mette dentro anche la forma " ++ " dei gruppi multi-opzione: due
   scrittori sullo stesso campo significano selezione non deterministica al
   checkout. In più quella UI non legge né option.disabled né data-price-diff,
   quindi perde esaurito e differenze di prezzo.

   Qui invece il <select> resta l'unica sorgente dei dati inviati al carrello:
   lo swatch scrive select.value e spara un change, e da lì in poi è tutto
   lavoro dell'app. Noi restiamo una pelle.

   VINCOLI DELL'APP (letti in simple-bundles-v2.min.js)
   - le opzioni le scrive dentro [data-simple-bundles-options] con innerHTML="",
     quindi nulla di nostro può vivere lì dentro: gli swatch stanno in un
     contenitore fratello;
   - ri-renderizza a ogni cambio variante, più una volta a 500 ms dal load: i
     <select> diventano elementi nuovi e vanno riagganciati. Per questo il
     rebuild scatta sull'identità degli elementi, non sul loro contenuto.

   COME SI AGGANCIA UN'OPZIONE ALLA SUA VARIANTE
   Il testo delle opzioni NON è generato dal catalogo: è la lista di valori che
   il brand scrive nell'app quando configura il bundle, quindi il prefisso può
   non essere il titolo Shopify del prodotto. Caso reale, kit-labbra-
   personalizzabile: l'app manda "Matita labbra AllDayLove - 01 Pretty in Pink"
   per un prodotto che in catalogo si chiama "AllDayLove matita labbra lunga
   durata". L'unica parte che l'app ricopia dal catalogo è il titolo della
   variante, ed è su quella che ci si aggancia: un'opzione vale una variante se
   il suo testo finisce con " - <titolo variante>", o se coincide.
   Quando lo stesso nome variante esiste in più figli vince quello che copre più
   opzioni dello stesso gruppo (un gruppo di solito pesca da un prodotto solo) e,
   a parità, il titolo più lungo, che è il più specifico.

   DEGRADAZIONE
   Gli swatch si costruiscono solo se OGNI opzione di OGNI gruppo trova la sua
   variante e ha un colore (il catalogo lo prepara snippet-io-swatches.liquid).
   Se manca o è parziale non si costruisce nulla e restano i select nativi:
   meglio la UI dell'app che una fila di pallini grigi indistinguibili.

   Stato leggibile in console: window.__sbioSwatches (products = il catalogo,
   missing = le opzioni rimaste senza variante o senza colore).
*/
(function () {
  var WRAP = '[data-sb-io]';
  var READY = 'sb-io--ready';

  var state = null;
  var timer = null;

  // Il testo delle opzioni lo scrive una persona nell'admin dell'app, i titoli
  // arrivano dal catalogo: le due copie possono divergere sui caratteri furbi
  // e sugli spazi doppi, quindi si confrontano solo da normalizzate.
  function norm(s) {
    return String(s == null ? '' : s)
      .replace(/’/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // Il catalogo dello snippet, con i titoli normalizzati una volta sola.
  function products(wrap) {
    var el = wrap.querySelector('script[data-sb-io-shades]');
    if (!el) return null;

    var raw;
    try {
      raw = JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }

    var list = (raw && raw.products) || [];
    if (!list.length) return null;

    return list.map(function (child) {
      return {
        handle: child.handle,
        key: norm(child.title),
        variants: (child.variants || []).map(function (v) {
          return {
            key: norm(v.title),
            label: v.title,
            shade: v.shade,
            image: v.image
          };
        })
      };
    });
  }

  function selectsIn(wrap) {
    var app = wrap.querySelector('[data-simple-bundles-options]');
    return app ? Array.prototype.slice.call(app.querySelectorAll('select')) : [];
  }

  function realOptions(select) {
    return Array.prototype.filter.call(select.options, function (o) {
      return o.value !== '';
    });
  }

  function groupTitle(select) {
    var prev = select.previousElementSibling;
    if (prev && prev.tagName === 'LABEL') return prev.textContent.trim();
    var byFor = select.id && document.querySelector('label[for="' + select.id + '"]');
    return byFor ? byFor.textContent.trim() : '';
  }

  // Con show_price_variance l'app appende la differenza al TESTO dell'opzione
  // (" (+€2,00)") lasciando pulito il value. Il suffisso si ricava per
  // differenza e finisce sotto lo swatch, altrimenti sparirebbe dalla vista.
  function priceSuffix(opt) {
    var text = (opt.textContent || '').trim();
    var value = (opt.value || '').trim();
    return value && text.indexOf(value) === 0 ? text.slice(value.length).trim() : '';
  }

  // Stesse due strade di sections/product-main.liquid: shade come URL immagine
  // oppure come colore. L'immagine del prodotto è l'ultima spiaggia.
  function paint(label, info) {
    var shade = info.shade || '';
    if (/^(https?:)?\/\//.test(shade) || shade.charAt(0) === '/') {
      label.style.setProperty('--palettebg', 'url(' + shade + ')');
      return true;
    }
    if (shade) {
      label.style.setProperty('--palettecolor', shade);
      return true;
    }
    if (info.image) {
      label.style.setProperty('--palettebg', 'url(' + info.image + ')');
      return true;
    }
    return false;
  }

  // Tutte le varianti del catalogo compatibili con il testo di un'opzione.
  function candidates(catalog, value) {
    var v = norm(value);
    var out = [];

    catalog.forEach(function (child) {
      child.variants.forEach(function (info) {
        var t = info.key;
        if (!t) return;

        var tail = ' - ' + t;
        if (v === t || (v.length > tail.length && v.slice(v.length - tail.length) === tail)) {
          out.push({ child: child, info: info, len: t.length });
          return;
        }

        // Figlio a variante unica: Shopify la chiama "Default Title" e l'app
        // scrive il solo nome del prodotto, quindi non c'è nessun suffisso da
        // agganciare. len 0: è la corrispondenza più debole, perde ogni pareggio.
        if (t === 'default title' && child.key) {
          if (v === child.key || v.indexOf(child.key) === 0 || child.key.indexOf(v) === 0) {
            out.push({ child: child, info: info, len: 0 });
          }
        }
      });
    });

    return out;
  }

  // Array parallelo alle opzioni del gruppo: la variante di ciascuna, o null.
  function resolve(opts, catalog) {
    var lists = opts.map(function (opt) {
      return candidates(catalog, opt.value);
    });

    // Quante opzioni del gruppo copre ciascun figlio: è il criterio che scioglie
    // i pareggi quando due prodotti hanno una variante con lo stesso nome.
    var covered = {};
    lists.forEach(function (list) {
      var seen = {};
      list.forEach(function (c) {
        if (seen[c.child.handle]) return;
        seen[c.child.handle] = true;
        covered[c.child.handle] = (covered[c.child.handle] || 0) + 1;
      });
    });

    return lists.map(function (list) {
      var best = null;
      list.forEach(function (c) {
        if (!best) {
          best = c;
          return;
        }
        var mine = covered[c.child.handle] || 0;
        var theirs = covered[best.child.handle] || 0;
        if (mine > theirs || (mine === theirs && c.len > best.len)) best = c;
      });
      return best ? best.info : null;
    });
  }

  function pick(input) {
    var data = input.__sbio;
    if (!data) return;

    Array.prototype.forEach.call(
      data.ul.querySelectorAll('input[type="radio"]'),
      function (other) {
        if (other !== input) other.checked = false;
      }
    );
    input.checked = true;

    if (data.select.value === data.value) return;
    data.select.value = data.value;
    data.select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function buildGroup(select, gi, infos) {
    var box = document.createElement('div');
    box.className = 'sb-io__group';

    var title = groupTitle(select);
    if (title) {
      var heading = document.createElement('h3');
      heading.className = 'sb-io__title';
      heading.textContent = title;
      box.appendChild(heading);
    }

    var ul = document.createElement('ul');
    ul.className = 'clio-palette-selector sb-io__palette';
    ul.setAttribute('role', 'group');
    if (title) ul.setAttribute('aria-label', title);

    realOptions(select).forEach(function (opt, oi) {
      var info = infos[oi] || {};
      var li = document.createElement('li');

      var input = document.createElement('input');
      input.type = 'radio';
      input.id = 'sb-io-' + gi + '-' + oi;
      // Nessun name: un radio senza name non viene inviato con il form — i dati
      // li manda il <select> dell'app — e l'esclusività la fa pick().
      input.checked = opt.selected;
      if (opt.disabled) {
        // La classe è quella su cui il tema disegna la X e il barrato; la
        // proprietà disabled rende inerte anche il click sulla <label for>.
        input.className = 'disabled';
        input.disabled = true;
      }
      input.__sbio = { select: select, value: opt.value, ul: ul };

      var label = document.createElement('label');
      label.setAttribute('for', input.id);
      var suffix = priceSuffix(opt);
      // "Default Title" non è un nome da mostrare: per i figli a variante unica
      // l'etichetta buona è quella scritta nell'app.
      var text = info.label && info.key !== 'default title' ? info.label : opt.value;
      label.textContent = text + (suffix ? ' ' + suffix : '');
      label.title = opt.value;
      paint(label, info);

      li.appendChild(input);
      li.appendChild(label);
      ul.appendChild(li);
    });

    box.appendChild(ul);
    return box;
  }

  function sync(wrap) {
    Array.prototype.forEach.call(
      wrap.querySelectorAll('[data-sb-io-groups] input[type="radio"]'),
      function (input) {
        var data = input.__sbio;
        if (data) input.checked = data.select.value === data.value;
      }
    );
  }

  function same(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  // Non basta l'identità degli elementi: show_price_variance riscrive il testo
  // delle <option> DOPO averle inserite, e rank_options_by_price_diff le
  // riordina. Il testo entra quindi nell'impronta, così un ritocco tardivo
  // dell'app rigenera le label invece di restare indietro in silenzio.
  function fingerprint(selects) {
    return selects
      .map(function (select) {
        return (
          select.name +
          '|' +
          realOptions(select)
            .map(function (o) {
              return o.value + '~' + (o.textContent || '').trim() + '~' + (o.disabled ? 1 : 0);
            })
            .join('~~')
        );
      })
      .join('||');
  }

  function teardown(groups, wrap) {
    state.selects = [];
    state.fp = '';
    state.ready = false;
    groups.innerHTML = '';
    wrap.classList.remove(READY);
  }

  function build() {
    var wrap = state.wrap;
    var groups = wrap.querySelector('[data-sb-io-groups]');
    var selects = selectsIn(wrap);

    state.selectCount = selects.length;

    if (!selects.length || !state.products) {
      teardown(groups, wrap);
      return;
    }

    // L'app ha solo ridisegnato gli stessi select: basta riallineare i pallini.
    var fp = fingerprint(selects);
    if (state.ready && state.fp === fp && same(state.selects, selects)) {
      sync(wrap);
      return;
    }

    // Prima si risolve tutto, poi si disegna: basta un'opzione senza variante o
    // senza colore e si resta sui select nativi.
    state.missing = [];
    var resolved = selects.map(function (select) {
      var opts = realOptions(select);
      var infos = resolve(opts, state.products);
      infos.forEach(function (info, i) {
        if (!info || (!info.shade && !info.image)) state.missing.push(opts[i].value);
      });
      return infos;
    });

    if (state.missing.length) {
      teardown(groups, wrap);
      return;
    }

    groups.innerHTML = '';
    selects.forEach(function (select, gi) {
      groups.appendChild(buildGroup(select, gi, resolved[gi]));
    });

    state.selects = selects;
    state.fp = fp;
    state.ready = true;
    wrap.classList.add(READY);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(build, 50);
  }

  function init() {
    if (state) return;

    var wrap = document.querySelector(WRAP);
    if (!wrap) return;

    state = window.__sbioSwatches = {
      wrap: wrap,
      products: products(wrap),
      sources: wrap.getAttribute('data-sb-io-sources') || '',
      selects: [],
      fp: '',
      selectCount: 0,
      missing: [],
      ready: false
    };

    wrap.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.type === 'radio' && t.__sbio) {
        pick(t);
        return;
      }
      // Il <select> può cambiare anche senza passare da noi: lo riordina l'app
      // con rank_options_by_price_diff, o lo tocca un'altra app.
      if (t.tagName === 'SELECT') sync(wrap);
    });

    new MutationObserver(schedule).observe(wrap, {
      childList: true,
      subtree: true
    });

    build();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
/* ═══ Tag-Bundle-App — FINE ═══ */
